module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_voice02-ccabda19201abc4ca55cdb92cb906377.jpg";